import { z } from 'zod';

export const textKbFormSchema = z.object({
  text: z
    .string()
    .trim()
    .nonempty({ message: 'Information is required' })
    .min(100, 'At least 100 characters is required')
    .trim(),
});

export type TextKbFormValues = z.infer<typeof textKbFormSchema>;

export const textKbFormDefaultValues: TextKbFormValues = {
  text: '',
};
